// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RangeSlider-module_rangeContainer___DwG_4 {
  width: 70%;
  padding: 40px 5px 0 5px;
}

.RangeSlider-module_rangeSlider___HXr7B {
  height: 8px;
  background: rgba(120, 120, 120, 0.2);
  position: relative;
  border-radius: 3px;
}

.RangeSlider-module_rangeTrack___Kjb06 {
  height: 8px;
  top: 0;
  bottom: 0;
  background: rgba(120, 120, 120, 0.2);
  border-radius: 4px;
}

.RangeSlider-module_rangeTrack___Kjb06:nth-of-type(2) {
  background: #EC6728;
}

.RangeSlider-module_selectedRangeTrack___dRv8t {
  position: absolute;
  height: 8px;
  background: #EC6728;
  border-radius: 4px;
  top: 0;
  z-index: 1;
}

.RangeSlider-module_rangeThumb___bCyKV {
  height: 16px;
  width: 16px;
  border: 1px solid #EC6728;
  background-color: white;
  border-radius: 50%;
  cursor: grab;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 0 !important;
}

.RangeSlider-module_tooltip___VfGSl {
  position: absolute;
  top: -32px;
  background: #EC6728;
  color: #fff;
  padding: 4px 8px;
  font-size: 1.2rem;
  border-radius: 4px;
  white-space: nowrap;
  left: 50%;
  transform: translateX(-50%);
  transition: opacity 0.2s ease;
}

.RangeSlider-module_tooltip___VfGSl::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 7px 3px 0 3px;
  border-style: solid;
  border-color: #EC6728 transparent transparent transparent;
}

.RangeSlider-module_rangeLabels___A08M7 {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
  font-size: 1.2rem;
}`, "",{"version":3,"sources":["webpack://./src/components/input/RangeSlider.module.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,uBAAA;AACJ;;AAEA;EACI,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,WAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EACA,kBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;AACJ;;AAEA;EACI,YAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;EACA,6BAAA;AACJ;;AAEA;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,2BAAA;EACA,mBAAA;EACA,yDAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,iBAAA;AACJ","sourcesContent":[".rangeContainer {\r\n    width: 70%;\r\n    padding: 40px 5px 0 5px;\r\n}\r\n\r\n.rangeSlider {\r\n    height: 8px;\r\n    background: #78787833;\r\n    position: relative;\r\n    border-radius: 3px;\r\n}\r\n\r\n.rangeTrack {\r\n    height: 8px;\r\n    top: 0;\r\n    bottom: 0;\r\n    background: #78787833;\r\n    border-radius: 4px;\r\n}\r\n\r\n.rangeTrack:nth-of-type(2) {\r\n    background: #EC6728; // selected range\r\n}\r\n\r\n.selectedRangeTrack {\r\n    position: absolute;\r\n    height: 8px;\r\n    background: #EC6728;\r\n    border-radius: 4px;\r\n    top: 0;\r\n    z-index: 1;\r\n}\r\n\r\n.rangeThumb {\r\n    height: 16px;\r\n    width: 16px;\r\n    border: 1px solid #EC6728;\r\n    background-color: white;\r\n    border-radius: 50%;\r\n    cursor: grab;\r\n    position: relative;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 0 !important;\r\n}\r\n\r\n.tooltip {\r\n    position: absolute;\r\n    top: -32px;\r\n    background: #EC6728;\r\n    color: #fff;\r\n    padding: 4px 8px;\r\n    font-size: 1.2rem;\r\n    border-radius: 4px;\r\n    white-space: nowrap;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    transition: opacity 0.2s ease;\r\n}\r\n\r\n.tooltip::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    bottom: -5px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    border-width: 7px 3px 0 3px;\r\n    border-style: solid;\r\n    border-color: #EC6728 transparent transparent transparent;\r\n}\r\n\r\n.rangeLabels {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-top: 1rem;\r\n    font-size: 1.2rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rangeContainer": `RangeSlider-module_rangeContainer___DwG_4`,
	"rangeSlider": `RangeSlider-module_rangeSlider___HXr7B`,
	"rangeTrack": `RangeSlider-module_rangeTrack___Kjb06`,
	"selectedRangeTrack": `RangeSlider-module_selectedRangeTrack___dRv8t`,
	"rangeThumb": `RangeSlider-module_rangeThumb___bCyKV`,
	"tooltip": `RangeSlider-module_tooltip___VfGSl`,
	"rangeLabels": `RangeSlider-module_rangeLabels___A08M7`
};
export default ___CSS_LOADER_EXPORT___;
